import { useEffect, useState } from "react"
import { SettingsGroup } from "../../../Modules/General"
import * as Basic from "../../../Modules/BasicFields"


export default function CanvasWall( props )
{
    const dynoCfg = props.dynoCfg 
    const setDynoCfg = props.setDynoCfg

    const [ hashtag, setHashtag ] = useState(null)
    const [ hashtagRate, setHashtagRate ] = useState(null)
    const [ height, setHeight ] = useState(null)
    const [ width, setWidth ] = useState(null)

    const requiredData = [
        hashtag,
        hashtagRate,
        height,
        width
    ]

    const cfgName = "echo_chambers_canvas_wall_cfg"

    const reload = () => {
        let properties = dynoCfg.properties
        let cfg = properties[cfgName] || {}

        setHashtag( cfg.hashtag || "")
        setHashtagRate( cfg.voting_rate || "one_per_user")
        setHeight((cfg.height != null ) ? cfg.height : 10)
        setWidth((cfg.width != null ) ? cfg.width : 10)
    }

    useEffect( () => {
        reload()
    },[])

    useEffect( () => {

        if( requiredData.includes(null) )
        {
            return
        }
        
        let data = {}
        data.hashtag = hashtag
        data.hashtag_rate = hashtagRate 
        data.height = height 
        data.width = width 

        let cfg = structuredClone(dynoCfg)
        cfg.properties[cfgName] = data
        setDynoCfg(cfg)
    },[ hashtag, hashtagRate, height, width ])

    if( requiredData.includes(null) )
    {
        return <></>
    }

    return (
        <>
            <SettingsGroup name="Behaviour"> 
                <Basic.StringInput name="Hashtag" value={hashtag} setValue={setHashtag} />
                <Basic.SelectInput name="Frequency per viewer" value={hashtagRate} setValue={setHashtagRate} 
                                   options={[
                                        { label: "One time only", value: "one_per_user" },
                                        { label: "Once every 10 seconds", value: "one_every_10_seconds" },
                                        { label: "Once every minute", value: "one_every_minute" },
                                        { label: "Unlimited", value: "unlimited" },
                                   ]}
                />
                <Basic.PositiveIntegerInput name="Height" value={height} setValue={setHeight} />
                <Basic.PositiveIntegerInput name="Width" value={width} setValue={setWidth} /> 
            </SettingsGroup> 
        </>
    )
}
